module.exports = __webpack_public_path__ + "media/images/proof_links/meetup-77e026468b30493f72a854a2be78d5bb.svg";